<script setup lang="ts">
import MenuList from '../../../components/menu/MenuList.vue'
import SeoHeadline from '../../../components/page-footer/SeoHeadline.vue'
import SocialLinks from '../../../components/shared/SocialLinks.vue'
import FooterAboTeaser from './FooterAboTeaser.vue'
import AiNotice from '../../../components/content-footer/AiNotice.vue'

import type { ComposedPage } from '@xcel-next/composer-schema'
import type { Brand } from '@xcel-next/core/enums'

defineProps<{
  footerData?: ComposedPage['footer'],
  brand?: Brand
}>()
</script>

<template>
  <div class="bx-flooding bx-flooding--footer">
    <footer class="bx-footer bx-typo--footer">
      <div class="bx-footer__wrapper">
        <div class="bx-grid">
          <SeoHeadline />
          <FooterAboTeaser />
          <SocialLinks menu-type="footer"
                       :brand="brand" />
        </div>
      </div>

      <div class="bx-footer__menu">
        <div class="bx-grid">
          <MenuList :menu="footerData?.menu"
                    menu-type="footer" />
          <AiNotice />
        </div>
      </div>
    </footer>
  </div>
</template>
